import React from 'react';
import { Empty } from 'antd';

interface DashboardEmptyStateProps {
  message?: string;
  suggestion?: string;
  icon?: React.ReactNode;
}

export const DashboardEmptyState: React.FC<DashboardEmptyStateProps> = ({
  message = 'No data for the selected period.',
  suggestion = 'Try adjusting the date range filter.',
  icon,
}) => (
  <div className="dashboard-empty-state">
    <Empty
      image={icon ?? Empty.PRESENTED_IMAGE_SIMPLE}
      description={
        <div className="dashboard-empty-state-content">
          <span className="dashboard-empty-state-message">{message}</span>
          <span className="dashboard-empty-state-suggestion">{suggestion}</span>
        </div>
      }
      style={{ padding: '48px 24px' }}
    />
  </div>
);
